import {CONFIG} from '@/config';
import {httpService} from '@/services';

export interface IAnalyticsService {
  analyticsReport(projectId: string | number, areaId: string | number, reportId: string | number): void;
}

export class AnalyticsService implements IAnalyticsService {
  analyticsReport(projectId: string | number, areaId: string | number, reportId: string | number): void {
    httpService.http
        .post(`${CONFIG.URL.NEODASH_API}/api/report/accessReport/${projectId}/${areaId}/${reportId}`)
        .then(() => {
          console.log('SUCCESS');
        })
        .catch((err) => {
          console.log('ERROR: ', err);
        });
  }
}

export const analyticsService = new AnalyticsService();
